module.exports = __webpack_public_path__ + "img/ug334.dae2e338.png";